// extracted by mini-css-extract-plugin
module.exports = {"custom_modal":"index_custom_modal__Xh1Q5","title__wrapper":"index_title__wrapper__hhrc3","warning__icon":"index_warning__icon__C_fAW"};